import Vue from "vue";
import VueRouter from "vue-router";
import SocialSharing from "vue-social-sharing";
import VueGitHubButtons from "vue-github-buttons";
import "vue-github-buttons/dist/vue-github-buttons.css";
import App from "./App.vue";
import "@/assets/scss/white-dashboard.scss";
import "@/assets/css/nucleo-icons.css";
import "@/assets/demo/demo.css";

import GlobalComponents from "./globalComponents";
import globalVariable from "./globalVariable";
import GlobalDirectives from "./globalDirectives";
import RTLPlugin from "./RTLPlugin";
import Notify from "@/components/NotificationPlugin";
import i18n from "./i18n";
import SideBar from "@/components/SidebarPlugin";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueTheMask from "vue-the-mask";
import VueGeolocation from "vue-browser-geolocation";
import Axios from "axios";
import VueAxios from "vue-axios";
import VueCookies from "vue-cookies";
import VueAutosuggest from "vue-autosuggest";
import VueSessionStorage from "vue-sessionstorage";
import jwt from "jsonwebtoken";

// element ui language configuration
import lang from "element-ui/lib/locale/lang/en";
import locale from "element-ui/lib/locale";
locale.use(lang);

Vue.config.productionTip = false;
Axios.defaults.baseURL = process.env.VUE_APP_API_ADDRESS;

// router setup
import routes from "./router";
Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  linkExactActiveClass: "active",
});

// 🔹 ÚNICO GUARD GLOBAL
router.beforeEach((to, from, next) => {
  const token = getDataSession("w_");
  let lvlAccess = 0;

  // Descobre nível de acesso conforme suas chaves
  jwt.verify(token, globalVariable.KEY_LEVEL_7, (err, decoded) => {
    if (decoded) lvlAccess = Math.max(lvlAccess, 7);
  });
  jwt.verify(token, globalVariable.KEY_LEVEL_10, (err, decoded) => {
    if (decoded) lvlAccess = Math.max(lvlAccess, 10);
  });

  const isLogged = lvlAccess > 0;
  const isPublic = to.matched.some((r) => r.meta && r.meta.public);
  const requiredLevel =
    to.meta && typeof to.meta.levelAccess === "number"
      ? to.meta.levelAccess
      : 0;

  // 1) libera páginas públicas sem exigir login
  if (isPublic) return next();

  // 2) se precisa login e não tem sessão, limpa e redireciona
  if (!isLogged) {
    deleteAllCookies();
    deleteSession();
    return next({ name: "login", query: { redirect: to.fullPath } });
  }

  // 3) checa nível
  if (lvlAccess >= requiredLevel) {
    return next();
  } else {
    return next(from && from.name ? { name: from.name } : { path: "/home" });
  }
});

function deleteAllCookies() {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}

function getDataSession(key) {
  const sessionKey = window.sessionStorage.getItem("sessionKey");
  const dados = window.sessionStorage.getItem(sessionKey);
  if (dados) return JSON.parse(dados)[key];
  return null;
}

function deleteSession() {
  const sessionKey = window.sessionStorage.getItem("sessionKey");
  window.sessionStorage.removeItem(sessionKey);
}

Vue.use(Element);
Vue.use(SocialSharing);
Vue.use(VueGitHubButtons, { useCache: true });
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(RTLPlugin);
Vue.use(SideBar);
Vue.use(Notify);
Vue.use(VueTheMask);
Vue.use(VueGeolocation);
Vue.use(VueAxios, Axios);
Vue.use(VueAutosuggest);
Vue.use(VueCookies);
Vue.use(VueSessionStorage);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
